/* ==========================================================================
   Foreva Kaash — slot machine SMS pop-up (2026-10-31, Gibbs). Port of Krazy
   Ambitions' assets/kza-slot.js (verified live there 2026-10-20).

   Flow:  trigger (delay / desktop exit intent) -> pull the lever (drag or tap)
          or tap Pull -> three reels spin and ALWAYS land on the jackpot
          (three FK logos = the prize, 10% off) -> "Claim" -> the game closes
          and the Omnisend signup dialog opens (sections/fk-signup.liquid,
          assets/fk-signup.js). Omnisend's embedded form collects the number;
          Omnisend owns consent and the code. If that form has not rendered
          (blocked/slow), Claim is a real <a href> to Omnisend's hosted signup.

   Why not an Omnisend pop-up opened from code (omnisend.push(['openForm', id])):
   on Krazy every hard bug came from a third-party pop-up built out of sight
   behind the game (hidden impressions, a lost +1 country code, double pop-ups).
   The embedded form is already drawn inside our own dialog and only shows
   when we open it, so none of that can happen.

   Lifecycle (once per visitor, cooldown after a dismiss, reopen tab, subscriber
   skip, scroll lock) is unchanged from Krazy (ported from Dead Romance's grave dig).
   Every tunable is a data-sm-* attribute written by snippets/fk-slot.liquid
   from Theme settings > Slot machine pop-up. Nothing commercial lives here.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-fk-slot]');
  if (!root || typeof root.showModal !== 'function') return;

  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function attr(n) { return (root.getAttribute('data-sm-' + n) || '').trim(); }
  var signup = document.querySelector('dialog[data-fk-signup]');        // sections/fk-signup.liquid (empty form ID = not rendered)
  var cfg = {
    enabled:      attr('enabled') === 'true',
    formId:       signup ? (signup.getAttribute('data-fk-form-id') || '').trim() : '',
    fallbackUrl:  attr('fallback-url'),
    delay:        num(attr('delay'), 6),
    exitIntent:   attr('exit-intent') === 'true',
    cooldownDays: num(attr('cooldown-days'), 7),
    force:        /[?&]fk_slot=1\b/.test(location.search)
  };
  // Auto-open only once it is switched on AND Claim has somewhere to go.
  var ready = cfg.enabled && !!(cfg.formId || cfg.fallbackUrl);

  var KEY = 'fk_slot_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('fk:slot', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */

  // Visitors arriving from our own texts/emails are already on the list.
  function fromOurTexts() { return /utm_source=omnisend/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // Already signed up through this form: Omnisend sets omnisend-form-{id}-filled-at (365 days) on submit, and
  // fk-signup.js marks the session once it has sent the Lead. Synchronous, but kept callback-shaped like Krazy's.
  function isSubscriber(cb) {
    if (!cfg.formId) return cb(false);
    var filled = document.cookie.indexOf('omnisend-form-' + cfg.formId + '-filled-at=') !== -1, sent = false;
    try { sent = sessionStorage.getItem('fk-lead-' + cfg.formId) === '1'; } catch (e) {}
    cb(filled || sent);
  }

  // Never stack on the cart drawer, the menu (both set html.fk-locked, assets/fk-shop.js) or another dialog.
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    return document.documentElement.classList.contains('fk-locked');
  }

  var shown = false, timer = null, formWaited = false;
  // Exactly one open per page: the delay timer and desktop exit intent can both fire, so the first trigger claims the
  // slot before checking (Krazy 2026-10-19, Gibbs: "it pops up once, and it instantly pops up again").
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    // Nowhere for Claim to go (Omnisend blocked or slow, no fallback link): give Omnisend one more beat, then stay closed.
    // A shopper must never win a prize they can't claim (2026-10-31: the hosted form link 301s to Omnisend's error page).
    if (!cfg.force && !cfg.fallbackUrl && !formRendered()) {
      if (!formWaited) { formWaited = true; timer = setTimeout(tryOpen, 4000); }
      return;
    }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    // A preview link (?fk_slot=1) always starts from scratch, so the whole animation can be reviewed again.
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);   // fetch the art just before it can open
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */

  var stage   = root.querySelector('[data-sm-stage]');
  var reels   = Array.prototype.slice.call(root.querySelectorAll('[data-sm-reel]'));
  var pullBtn = root.querySelector('[data-sm-pull]');
  var claimEl = root.querySelector('[data-sm-claim]');
  var lever   = root.querySelector('[data-sm-lever]');
  var live    = root.querySelector('[data-sm-live]');
  var fx      = root.querySelector('[data-sm-fx]');
  var won = false, spinning = false, claimed = false;

  var keyboardUser = false;   // move focus to Claim only for keyboard users: no stray focus ring on touch
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);

  function setState(s) { root.setAttribute('data-sm-state', s); }

  /* ------------------------------------------------------- lazy art (once) */
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    // The machine photo: one plain src (never srcset), the 720w file wherever it covers the drawn size.
    var base = root.querySelector('[data-sm-photo-img]');
    if (base) {
      var drawn = (window.innerWidth < 900 ? Math.min(window.innerWidth, 480) * 0.9 : 470) * Math.min(window.devicePixelRatio || 1, 3);
      base.src = drawn <= 760 && base.getAttribute('data-src-sm') ? base.getAttribute('data-src-sm') : base.getAttribute('data-src');
      base.removeAttribute('data-src'); base.removeAttribute('data-src-sm');
    }
    Array.prototype.forEach.call(root.querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src'); img.removeAttribute('data-src');
    });
  }

  /* ------------------------------------------------------ scroll lock (html)
     showModal() traps focus but the page behind still scrolls on iOS; lock <html>
     (not <body>) and give the scrollbar's width back so nothing shifts. */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('fk-slot-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('fk-slot-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  var opening = false;
  function artReady(cb) {
    var imgs = [root.querySelector('[data-sm-photo-img]'), root.querySelector('[data-sm-rod]'), root.querySelector('[data-sm-ballimg]')]
      .concat(Array.prototype.slice.call(root.querySelectorAll('.sm-strip .sm-tile__img')).slice(0, 12)).filter(Boolean);
    var done = false, finish = function () { if (!done) { done = true; cb(); } };
    setTimeout(finish, 1200);
    Promise.all(imgs.map(function (i) {
      if (i.decode) return i.decode().catch(function () {});
      return new Promise(function (res) { if (i.complete) res(); else { i.onload = i.onerror = res; } });
    })).then(finish, finish);
  }
  function open() {
    if (root.open || opening) return;                              // never twice
    opening = true; shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    artReady(function () { opening = false; if (!root.open) revealGame(); });
  }
  function revealGame() {
    var s = readState();
    if (s.won && !won) showWonInstant();
    setState(won ? 'won' : 'ready');
    root.showModal(); lockScroll();
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    requestAnimationFrame(function () { reels.forEach(layoutReel); leverLayout(); sizeFx(); });
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target === root) root.close();                          // backdrop
    if (e.target.closest('[data-sm-close]')) root.close();
  });
  window.addEventListener('resize', function () { if (root.open) { reels.forEach(layoutReel); leverLayout(); sizeFx(); } });

  /* ------------------------------------------------------------------ reels
     Each reel is a strip of tiles (the same symbol order repeated LOOPS times).
     The strip moves by translateY; tile height = the reel's width (square tiles),
     measured at open so the machine can be any size. A spin travels at least three
     full loops and stops with the jackpot mark on the payline. */
  var LOOPS = 6;
  var START = [2, 1, 3];            // a mixed, non-winning line on first paint (index in each reel's order)
  var JACKPOT = 'mark';

  reels.forEach(function (reel, r) {
    var strip = reel.querySelector('[data-sm-strip]');
    var tiles = Array.prototype.slice.call(strip.children);
    reel._n = tiles.length;
    reel._jack = tiles.findIndex ? tiles.findIndex(function (t) { return t.getAttribute('data-sym') === JACKPOT; })
                                 : 0;
    var frag = document.createDocumentFragment();
    for (var l = 1; l < LOOPS; l++) tiles.forEach(function (t) { var c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true'); frag.appendChild(c); });
    strip.appendChild(frag);
    reel._strip = strip;
    reel._pos = START[r % START.length];     // tile index on the payline (fractional while moving)
  });

  function tileH(reel) { return (reel.clientHeight || 3) / 3; }   // three rows show: above, on and below the payline
  function yFor(reel, idx) {               // translateY that centres tile idx in the window
    var h = tileH(reel);
    return reel.clientHeight / 2 - (idx + 0.5) * h;
  }
  function paint(reel, idx) { reel._strip.style.transform = 'translate3d(0,' + yFor(reel, idx).toFixed(2) + 'px,0)'; }
  function layoutReel(reel) {
    Array.prototype.forEach.call(reel._strip.children, function (t) { t.style.height = tileH(reel) + 'px'; });
    paint(reel, reel._pos);
  }

  function easeOutQuart(p) { return 1 - Math.pow(1 - p, 4); }
  function easeOutBack(p) { var c = 1.9, c3 = c + 1; return 1 + c3 * Math.pow(p - 1, 3) + c * Math.pow(p - 1, 2); }

  // Spin one reel to the jackpot. Phases: a tiny upward kick (the lever's jolt),
  // the long run with an ease-out, an overshoot past the payline, and a settle back.
  function spinReel(reel, duration, done) {
    var n = reel._n, from = reel._pos;
    var loopsAhead = 3 + reels.indexOf(reel);                    // later reels travel further
    var target = (Math.floor(from / n) + loopsAhead) * n + reel._jack;
    if (target - from < 2 * n) target += n;
    target = Math.min(target, LOOPS * n - 2);
    var kick = reduceMotion ? 0 : 120, settle = reduceMotion ? 0 : 280, run = Math.max(200, duration - kick - settle);
    var over = 0.22, t0 = performance.now();
    reel.classList.add('is-moving');
    (function frame(now) {
      var t = now - t0, pos;
      if (t < kick) pos = from - 0.18 * Math.sin((t / kick) * Math.PI);
      else if (t < kick + run) {
        var p = (t - kick) / run;
        pos = from + (target + over - from) * easeOutQuart(p);
        reel.classList.toggle('is-blur', !reduceMotion && p < 0.72);
      } else if (t < kick + run + settle) {
        var q = (t - kick - run) / settle;
        pos = target + over - over * easeOutBack(q);
      } else pos = target;
      reel._pos = pos; paint(reel, pos);
      if (pos !== target) return requestAnimationFrame(frame);
      reel.classList.remove('is-moving', 'is-blur');
      reel._pos = reel._jack + n;                                // same tile, back in the first loops: room for another spin
      paint(reel, reel._pos);
      reel.classList.add('is-hit');
      done && done();
    })(t0);
  }

  function spin(source) {
    if (spinning || won) return;
    spinning = true; warm();
    setState('spinning');
    stage.classList.add('is-spinning');
    pullBtn && pullBtn.setAttribute('aria-disabled', 'true');
    emit('spin', { via: source });
    var D = reduceMotion ? [450, 600, 750] : [1500, 2150, 3300];   // reel 3 hangs: two marks are already up
    var stopped = 0;
    reels.forEach(function (reel, i) {
      spinReel(reel, D[i], function () {
        stopped++;
        if (stopped === 2) stage.classList.add('is-tease');         // two jackpots showing: the bulbs go frantic
        if (stopped === reels.length) jackpot();
      });
    });
  }

  function jackpot() {
    spinning = false; won = true;
    root.classList.remove('is-returning');
    if (!reduceMotion && navigator.vibrate) { try { navigator.vibrate([70, 40, 150]); } catch (e) {} }   // Android; iOS ignores it
    stage.classList.remove('is-spinning', 'is-tease');
    stage.classList.add('is-won');
    setState('won');
    writeState({ won: Date.now() });
    if (live) live.textContent = live.getAttribute('data-sm-live-won') || '';
    setTimeout(burst, 140);                                        // with the stamp's slam
    emit('jackpot');
    // The Pull button just disappeared, so focus would fall to <body>: keep it in the dialog.
    if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true });
  }
  // A returning winner (reopened from the tab, or another page): show the jackpot, no spin.
  function showWonInstant() {
    won = true;
    root.classList.add('is-returning');
    reels.forEach(function (reel) { reel._pos = reel._jack + reel._n; reel.classList.add('is-hit'); });
    stage.classList.add('is-won', 'is-instant');
    requestAnimationFrame(function () { reels.forEach(layoutReel); requestAnimationFrame(function () { stage.classList.remove('is-instant'); }); });
  }

  pullBtn && pullBtn.addEventListener('click', function () { if (!spinning && !won) { pullLever(true); } });
  // the three magenta buttons in the photo spin it too
  Array.prototype.forEach.call(root.querySelectorAll('[data-sm-btn]'), function (b) {
    b.addEventListener('click', function () { if (!spinning && !won) pullLever(true); });
  });

  /* ------------------------------------------------------------------ lever
     Drag the ball down (finger, mouse, pen) or tap it. Past 45% of the swing it fires; either way it
     springs back. The rod and ball are cut out of the photo. Seen head-on, a lever swinging toward the
     viewer foreshortens: the rod scales by cos(theta) about the hub pivot (flipping below it past 90deg),
     the ball rides the rod's tip and swells a little as it comes closer. Geometry: data-pivot / data-ball
     on [data-sm-lever], fractions of the photo, written by scripts/prepare_slot_photo.py. */
  var MAXA = 150 * Math.PI / 180, leverA = 0, dragging = false, dragY0 = 0, dragA0 = 0, leverRAF = 0;
  var photo = root.querySelector('[data-sm-photo]');
  var rodEl = lever && lever.querySelector('[data-sm-rod]'), ballEl = lever && lever.querySelector('[data-sm-ballimg]');
  var gripEl = lever && lever.querySelector('[data-sm-grip]');
  function frac(name) { var v = (lever.getAttribute(name) || '0,0').split(','); return [parseFloat(v[0]) || 0, parseFloat(v[1]) || 0]; }
  var geo = null;
  function leverLayout() {
    if (!lever || !photo || !rodEl) return;
    var W = photo.clientWidth, H = photo.clientHeight, pv = frac('data-pivot'), bl = frac('data-ball');
    geo = { px: pv[0] * W, py: pv[1] * H, bx: bl[0] * W, by: bl[1] * H };
    rodEl.style.transformOrigin = (geo.px - rodEl.offsetLeft).toFixed(1) + 'px ' + (geo.py - rodEl.offsetTop).toFixed(1) + 'px';
    drawLever(leverA);
  }
  function drawLever(a) {
    leverA = a;
    if (!geo) return;
    var c = Math.cos(a), s = Math.sin(a);
    rodEl.style.transform = 'scale(' + (1 + 0.05 * s).toFixed(4) + ',' + c.toFixed(4) + ')';
    var dx = (geo.bx - geo.px) * (c - 1), dy = (geo.by - geo.py) * (c - 1), t = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
    if (ballEl) ballEl.style.transform = t + ' scale(' + (1 + 0.24 * s).toFixed(4) + ')';
    if (gripEl) gripEl.style.transform = t;
  }
  function animateLever(to, ms, cb) {
    cancelAnimationFrame(leverRAF);
    var from = leverA, t0 = performance.now();
    if (reduceMotion) ms = Math.min(ms, 120);
    (function f(now) {
      var p = Math.min(1, (now - t0) / ms), e = to === 0 ? easeOutBack(p) : easeOutQuart(p);
      drawLever(from + (to - from) * (to === 0 ? Math.min(e, 1.04) : e));
      if (p < 1) leverRAF = requestAnimationFrame(f); else { drawLever(to); cb && cb(); }
    })(t0);
  }
  function pullLever(fire) {
    animateLever(MAXA, 230, function () {
      if (fire) spin('lever');
      setTimeout(function () { animateLever(0, 520); }, 90);
    });
  }
  if (lever) {
    drawLever(0);
    var grip = gripEl || lever;
    // The ball tracks the finger: its drop below rest is L*(1 - cos(theta)), so theta = acos(1 - drop / L).
    var armLen = function () { return Math.max(40, geo ? geo.py - geo.by : 120); };
    var angleFor = function (drop) { return Math.acos(Math.max(Math.cos(MAXA), Math.min(1, 1 - drop / armLen()))); };
    grip.addEventListener('pointerdown', function (e) {
      if (spinning || won) return;
      dragging = true; dragY0 = e.clientY; dragA0 = leverA; cancelAnimationFrame(leverRAF);
      try { grip.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault();
    });
    grip.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      drawLever(angleFor(Math.max(0, e.clientY - dragY0 + armLen() * (1 - Math.cos(dragA0)))));
    });
    var release = function (e) {
      if (!dragging) return; dragging = false;
      var moved = Math.abs(e.clientY - dragY0) > 6, p = leverA / MAXA;
      if (!moved) return pullLever(true);                          // a tap pulls it all the way
      if (p > 0.45) { animateLever(MAXA, 90, function () { spin('lever'); setTimeout(function () { animateLever(0, 520); }, 60); }); }
      else animateLever(0, 360);
    };
    grip.addEventListener('pointerup', release);
    grip.addEventListener('pointercancel', release);
    grip.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); if (!spinning && !won) pullLever(true); }
    });
  }

  /* ---------------------------------------------------------- jackpot burst
     One orchestrated moment: gold coins and magenta four-point sparks (the FK
     cross's points) fountain out of the coin tray, then fall. Skipped for reduced motion. */
  var fxCtx = fx ? fx.getContext('2d') : null;
  function sizeFx() {
    if (!fx) return;
    var r = fx.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
    fx.width = Math.round(r.width * dpr); fx.height = Math.round(r.height * dpr);
    fxCtx && fxCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function burst() {
    if (!fxCtx || reduceMotion) return;
    sizeFx();
    var fr = fx.getBoundingClientRect(), tray = root.querySelector('[data-sm-tray]');
    var tr = tray ? tray.getBoundingClientRect() : { left: fr.left + fr.width / 2 - 40, width: 80, top: fr.top + fr.height * .8 };
    var ox = tr.left - fr.left + tr.width / 2, oy = tr.top - fr.top + 6, parts = [], i, small = fr.width < 600, n = small ? 70 : 96;
    for (i = 0; i < n; i++) {                                       // fountain out of the coin tray
      var spark = i % 5 === 0, a = -Math.PI / 2 + (Math.random() - .5) * 1.7, v = (spark ? 8 : 7) + Math.random() * 7;
      parts.push({ x: ox + (Math.random() - .5) * tr.width * .7, y: oy, vx: Math.cos(a) * v * .85, vy: Math.sin(a) * v * 1.35,
                   r: spark ? 8 + Math.random() * 7 : 7 + Math.random() * 6, spin: Math.random() * 6, vs: .15 + Math.random() * .25, spark: spark, delay: Math.random() * 500 });
    }
    for (i = 0; i < (small ? 44 : 70); i++) {                       // and a rain of coins from the top
      parts.push({ x: Math.random() * fr.width, y: -20 - Math.random() * 160, vx: (Math.random() - .5) * 1.2, vy: 1 + Math.random() * 3,
                   r: 6 + Math.random() * 6, spin: Math.random() * 6, vs: .12 + Math.random() * .22, spark: i % 6 === 0, delay: 150 + Math.random() * 900 });
    }
    var t0 = performance.now();
    (function f(now) {
      var t = now - t0; fxCtx.clearRect(0, 0, fr.width, fr.height);
      parts.forEach(function (p) {
        if (t < p.delay) return;
        p.vy += .3; p.x += p.vx; p.y += p.vy; p.spin += p.vs;
        fxCtx.save(); fxCtx.translate(p.x, p.y);
        fxCtx.globalAlpha = Math.max(0, Math.min(1, (3200 - t) / 700));
        if (p.spark) {
          fxCtx.rotate(p.spin); fxCtx.fillStyle = '#ff5fcf'; fxCtx.shadowColor = 'rgba(215,59,169,.9)'; fxCtx.shadowBlur = 10;
          fxCtx.beginPath();
          for (var k = 0; k < 4; k++) { fxCtx.rotate(Math.PI / 2); fxCtx.moveTo(0, 0); fxCtx.quadraticCurveTo(p.r * .35, -p.r * .45, 0, -p.r * 1.6); fxCtx.quadraticCurveTo(-p.r * .35, -p.r * .45, 0, 0); }
          fxCtx.fill();
        } else {
          var sx = Math.abs(Math.cos(p.spin));                     // a coin flipping edge-on
          fxCtx.scale(Math.max(.12, sx), 1);
          fxCtx.fillStyle = '#c98f12'; fxCtx.beginPath(); fxCtx.arc(0, 0, p.r, 0, 6.283); fxCtx.fill();
          fxCtx.fillStyle = '#ffc64a'; fxCtx.beginPath(); fxCtx.arc(0, -.6, p.r * .78, 0, 6.283); fxCtx.fill();
          fxCtx.fillStyle = 'rgba(255,255,255,.65)'; fxCtx.beginPath(); fxCtx.arc(-p.r * .25, -p.r * .3, p.r * .22, 0, 6.283); fxCtx.fill();
        }
        fxCtx.restore();
      });
      if (t < 3200) requestAnimationFrame(f); else fxCtx.clearRect(0, 0, fr.width, fr.height);
    })(t0);
  }

  /* ----------------------------------------------------------------- claim
     The signup dialog's embedded Omnisend form has been drawn (hidden) since page load, so Claim swaps the game for it
     in one tap: close the game, open the signup dialog. Omnisend collects the number and texts the code. If the form
     has not rendered (Omnisend blocked or slow), Claim stays a native link to the hosted signup page in a new tab.
     fk-signup.js sends the Meta Lead on a confirmed phone submit; it reads the label from the dialog, so the game
     labels the signup as its own while it is open and puts the dialog's labels back when it closes. */
  function formRendered() {
    var mount = signup && signup.querySelector('.fk-signup__form');
    return !!(mount && mount.querySelector('input'));
  }
  function openSignup() {
    var d = signup.dataset, keep = { name: d.fkLeadName, cat: d.fkLeadCategory };
    d.fkLeadName = 'Slot machine SMS signup'; d.fkLeadCategory = 'slot_machine';
    signup.addEventListener('close', function restore() {
      signup.removeEventListener('close', restore);
      if (keep.name == null) delete d.fkLeadName; else d.fkLeadName = keep.name;
      if (keep.cat == null) delete d.fkLeadCategory; else d.fkLeadCategory = keep.cat;
    });
    signup.showModal();
    var field = signup.querySelector('input[type="tel"], input:not([type="hidden"])');
    if (field && keyboardUser) field.focus();
  }
  claimEl && claimEl.addEventListener('click', function (e) {
    var toForm = formRendered();
    if (!toForm && !cfg.fallbackUrl) {                             // nothing to hand off to yet (QA via ?fk_slot=1)
      e.preventDefault();
      var note = root.querySelector('[data-sm-setup-note]'); if (note) note.hidden = false;
      return;
    }
    claimed = true;
    writeState({ claimed: Date.now() });
    emit('claim', { via: toForm ? 'omnisend-embedded' : 'fallback-link' });
    hideTab();
    if (!toForm) return;                                           // the link opens the hosted form
    e.preventDefault();
    root.close();
    openSignup();
  });

  /* ------------------------------------------------- reopen tab (right edge)
     After a dismiss, a slim tab stays on the right edge so the game can be found
     again: "Pull it" before spinning, "Claim it" after a jackpot. */
  var tab = document.querySelector('[data-sm-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-sm-won', (won || readState().won) ? 'true' : 'false');
    function reveal() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return reveal();
    isSubscriber(function (sub) { if (!sub) reveal(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-sm-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-sm-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    // a signup made in the dialog (from the game or a Remind me link) retires the tab
    window.addEventListener('omnisendForms', function (e) { var d = e.detail || {}; if ((d.type || d.eventName) === 'submit') hideTab(); });
    // Never sit on a way to pay: tuck off the edge while overlapping an add-to-bag or sticky buy bar.
    var BUY = 'form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], .shopify-payment-button, ' +
              'shopify-accelerated-checkout, [class*="sticky"] button, [data-sticky-atc], .fk-sticky';
    var tq = false;
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function tuck() {
      tq = false; if (tab.hidden) return;
      var w = tab.offsetWidth, h = tab.offsetHeight, cy = window.innerHeight * .56;   // resting box, computed (CSS: right 0, top 56%)
      var r = { left: document.documentElement.clientWidth - w - 10, right: window.innerWidth, top: cy - h / 2 - 10, bottom: cy + h / 2 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) { var b = els[i].getBoundingClientRect(); if (b.width && b.height && overlaps(r, b)) hit = true; }
      tab.classList.toggle('is-tucked', hit);
    }
    function queueTuck() { if (!tq) { tq = true; requestAnimationFrame(tuck); } }
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  // QA: ?fk_slot=1 forces it open from a fresh start (even while switched off); FK_SLOT.reset() clears the visitor memory.
  window.FK_SLOT = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  arm();
})();
